import { Component, OnInit } from '@angular/core';
import { ITableColumn, ETableColumnType } from 'app/store/models/table.model';
import { ISubscription } from 'app/store/models/subscription.model';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { HttpClient } from '@angular/common/http';
import { ButtonColor, ButtonSize, Button } from 'app/store/models/button.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { SubscriptionService } from 'app/store/services/subscription.service';
import { setFlash } from 'app/store/actions/user.action';
import { FLASH_TYPE } from 'app/store/models/user.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-list-subscriptions',
  templateUrl: './list-subscriptions.component.html',
  styleUrls: ['./list-subscriptions.component.scss'],
})
export class ListSubscriptionsComponent implements OnInit {
  createButtonProperties: Button = {
    color: ButtonColor.GREEN,
    size: ButtonSize.SMALL,
    text: 'Create New Team Code',
    route: ['/subscriptions', 'new'],
    style: 'outline',
  };

  tableColumns: ITableColumn<ISubscription>[] = [
    {
      id: 'team_code',
      title: 'Team Code',
    },
    {
      id: 'plan_id',
      title: 'Plan',
    },
    {
      id: 'plan_cost',
      title: 'Plan Cost',
    },
    {
      id: 'coupon_id',
      title: 'Coupon Id',
    },
    {
      id: 'subscription_cost',
      title: 'Initial cost',
    },
    {
      id: 'trial_days',
      title: 'Trial days',
    },
    {
      id: 'additional_user_cost',
      title: 'Additional cost',
    },
    {
      id: 'content_code',
      title: 'Content Code',
    },
    {
      id: 'campaign_name',
      title: 'Campaign Name',
    },
    {
      id: 'campaign_type',
      title: 'Campaign Type',
    },
    {
      id: 'credits',
      title: 'Credits',
    },
    {
      id: 'show',
      type: ETableColumnType.BUTTON,
      buttonProperties: {
        color: ButtonColor.BLUE,
        size: ButtonSize.SMALL,
        text: 'Show',
        style: 'outline',
      },
      route: (item: ISubscription) => `/subscriptions/${item.id}/view`,
    },
    {
      id: 'edit',
      type: ETableColumnType.BUTTON,
      buttonProperties: {
        color: ButtonColor.ORANGE,
        size: ButtonSize.SMALL,
        text: 'Edit',
        style: 'outline',
      },
      route: (item: ISubscription) => `/subscriptions/${item.id}/edit`,
    },
    {
      id: 'delete',
      type: ETableColumnType.BUTTON,
      buttonProperties: {
        color: ButtonColor.RED,
        size: ButtonSize.SMALL,
        text: 'Delete',
        style: 'outline',
        onClick: (item: ISubscription) =>
          this.store.dispatch(
            openDialog({
              dialogData: {
                content: 'Are you sure?',
                buttons: [
                  {
                    actAsClose: true,
                    color: ButtonColor.WHITE,
                    size: ButtonSize.SMALL,
                    text: 'Cancel',
                  },
                  {
                    actAsClose: true,
                    color: ButtonColor.RED,
                    size: ButtonSize.SMALL,
                    onClick: () => {
                      this.subscriptionService
                        .deleteSubscription(item.id)
                        .subscribe(() => {
                          this.store.dispatch(
                            setFlash({
                              data: {
                                type: FLASH_TYPE.ALERT,
                                alertMessage:
                                  'Team Code was deleted Successfully!',
                              },
                            })
                          );
                          this.dataSource.refresh();
                        });
                    },
                    text: 'Confirm',
                  },
                ],
                title: 'Please, confirm!',
              },
            })
          ),
      },
    },
    {
      id: 'expire',
      type: ETableColumnType.BUTTON,
      buttonProperties: {
        color: ButtonColor.GREEN,
        size: ButtonSize.SMALL,
        text: 'Expire',
        style: 'outline',
        onClick: item => this.expireSubscription(item),
      },
    },
  ];

  dataSource: ApiDataSource<ISubscription>;

  tableDataSourceParams: any = {
    page: 1,
    pageSize: 10,
  };

  tableReady: boolean;

  expireSubscription(item: ISubscription) {
    this.subscriptionService
      .updateSubscription(item.id, {
        ...item,
        expire: true,
      })
      .subscribe(() => {
        this.store.dispatch(
          setFlash({
            data: {
              type: FLASH_TYPE.ALERT,
              alertMessage: 'Team Code was set to Expired Successfully!',
            },
          })
        );
        this.dataSource.refresh();
      });
  }

  constructor(
    private http: HttpClient,
    private store: Store<IReducers>,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit() {
    this.dataSource = new ApiDataSource<ISubscription>(
      this.http,
      environment.apiUrl + '/v1/subscription/list'
    );
    this.tableReady = true;
  }
}
